import RoutePrivate from './RoutePrivate';

export default RoutePrivate;
